import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { GlobalModalRenderer } from "./lib/modal-renderer";
import { useRefreshMyInfo } from "./hooks/useRefreshMyInfo";
import { useFcmRegistration } from "./hooks/useFcmRegistration";
import { useMarketingPopupConfirm } from "./hooks/useMarketingPopupConfirm";
import { postToApp } from "./lib/bridge";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export default function App() {
  useRefreshMyInfo();
  useFcmRegistration();
  useMarketingPopupConfirm();

  useEffect(() => {
    postToApp("onJsLoadComplete");
  }, []);

  useEffect(() => {
    let lastPath = window.location.pathname;
    const pushPageview = () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pageview",
        page_path: window.location.pathname,
        page_title: document.title,
      });
    };
    pushPageview();
    const unsubscribe = router.subscribe((state) => {
      if (
        state.navigation.state === "idle" &&
        state.location.pathname !== lastPath
      ) {
        lastPath = state.location.pathname;
        pushPageview();
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <GlobalModalRenderer />
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar
        closeButton={false}
        toastClassName="custom-toast"
      />
    </>
  );
}
